export default __webpack_public_path__ + "static/media/QueenAnnesLace400.56af4cb9.jpg";